'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _themeProvider = require('@spp/theme-provider');

var _uiImage = require('@spp/ui-image');

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StreamerImageAsset = (0, _themeProvider.themer)('@spp/ui-streamer:image-asset')(_uiImage.ImageAsset);

var Streamer = function Streamer(_ref) {
    var text = _ref.text,
        theme = _ref.theme,
        image = _ref.image,
        stylizr = _ref.stylizr,
        subtype = _ref.subtype;

    var hasImage = image && image.imageAsset && image.imageAsset.urls;

    var title = _react2.default.createElement(
        'div',
        { className: theme.title },
        stylizr(text.value, text.markup)
    );

    var ImageStreamer = function ImageStreamer() {
        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(theme[subtype], theme.root), 'data-test-tag': '@spp/ui-streamer' },
            _react2.default.createElement(StreamerImageAsset, (0, _extends3.default)({}, image.imageAsset, {
                caption: text.value,
                theme: theme,
                width: image.imageAsset.size.width
            })),
            title
        );
    };

    var TextStreamer = function TextStreamer() {
        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(theme[subtype], theme.root), 'data-test-tag': '@spp/ui-streamer' },
            title
        );
    };

    return hasImage ? ImageStreamer() : TextStreamer();
};

Streamer.defaultProps = {
    image: undefined,
    stylizr: function stylizr(text) {
        return text;
    },
    subtype: undefined,
    theme: {}
};

Streamer.propTypes = {
    image: _propTypes2.default.shape(_uiImage.ImageAsset.propTypes),
    stylizr: _propTypes2.default.func.isRequired,
    subtype: _propTypes2.default.string.isRequired,
    text: _irisPropTypes.objects.text.isRequired,
    theme: {
        root: _propTypes2.default.string,
        title: _propTypes2.default.string
    }
};

exports.default = Streamer;
//# sourceMappingURL=Streamer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-streamer/lib/cjs/Streamer.js
 ** module id = 671
 ** module chunks = 1
 **/